import { ActionItemStatus } from "./actionItem";
export class ActionItemsSearchDataModel {
    constructor() {
        this.page = 1;
        this.pageSize = 10;
        this.sort = null;
        this.columnFilters = [];
        this.status = ActionItemStatus.Open;
    }
}
export default class ActionItemsSearchData extends ActionItemsSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
